import React from 'react';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlassian/jira-portfolio-3-common';
import type { SelectForColumnCellProps } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/select/types';
import { SelectForColumnCell } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/select/view';

export default function FieldPrioritySelect({ isDisabled, ...props }: SelectForColumnCellProps) {
	return (
		<SelectForColumnCell
			isDisabled={isDisabled}
			{...props}
			styles={{
				singleValue: (styles) => ({
					...styles,

					...(isDisabled === true ? { color: token('color.text.subtle', colors.N800) } : {}),
				}),
				multiValue: (styles) => ({
					...styles,

					...(isDisabled === true ? { color: token('color.text.subtle', colors.N800) } : {}),
				}),
				dropdownIndicator: (styles) => ({
					...styles,
					...(isDisabled === true ? { display: 'none' } : {}),
				}),
			}}
		/>
	);
}
